export default "__VITE_ASSET__89691bad__"